import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';

import { vMinLength } from '@tokenyico/design-system';
import { DsForm, DsInputString, DsButton } from '@tokenyico/design-system/dist/reactJS';

import { AuthenticationService } from 'services';
import { formActions } from 'app/state/actions';

const mapToProps = (state) => state;

const ConfirmSignUpAuthView = ({ location, history, setError, setSuccess }) => {
  const { t } = useTranslation();

  const [code, setCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const query = new URLSearchParams(location.search);
  const emailFromUrl = query.get('email');
  const codeFromUrl = query.get('code');
  const emailFromHistory = history.location.state && history.location.state.email;
  const email = emailFromUrl || emailFromHistory;

  useEffect(() => {
    setCode(codeFromUrl);
  }, [codeFromUrl]);

  async function onSubmit() {
    setIsSubmitting(true);
    try {
      await AuthenticationService.confirmSignUp({ username: email, code });
      setSuccess(t('shared.accountConfirmed'));
      history.push('/');
      setIsSubmitting(false);
    } catch (error) {
      if (
        error.code === 'NotAuthorizedException' &&
        error.message === t('shared.accountConfirmed')
      ) {
        setError(error.message);
        history.push('/auth/signin');
      } else if (error.code === 'CodeMismatchException') {
        setError(t('validation.verificationCodeInvalid'));
      } else {
        setError(error);
      }
      setIsSubmitting(false);
    }
  }

  async function handleResendCode() {
    setIsLoading(true);
    try {
      await AuthenticationService.resendSignUp(email);
      setSuccess(t('shared.checkEmail'));
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  }

  return (
    <div className="card auth">
      <h1 className="auth__title">{t('shared.confirmYourAccount')}</h1>
      <DsForm onSubmit={onSubmit} id="confirm-sign-up">
        <DsInputString
          label={t('shared.confirmationCode')}
          name="code"
          value={code}
          isFloatLabel={false}
          onDsInput={({ detail }) => setCode(detail)}
          validate={vMinLength(5)}
          className="_m:top(2)"
        />

        <div className="auth__button-primary">
          <DsButton
            version="primary"
            label={t('shared.confirm')}
            type="submit"
            isLoading={isSubmitting}
          />
        </div>
        <div className="auth__button-secondary">
          <DsButton
            mode="text"
            label={t('shared.resendConfirmationCode')}
            onClick={handleResendCode}
            isLoading={isLoading}
          />
        </div>
      </DsForm>
      <div className="auth__footer">
        <DsButton
          mode="text"
          label={t('shared.backToSignUp')}
          onClick={() => history.push('/auth/signup')}
          isFullWidth
        />
      </div>
    </div>
  );
};

export default connect(mapToProps, formActions)(ConfirmSignUpAuthView);
